import { ValidationQuestions } from "./ValidationQuestions";
export default ValidationQuestions;
